<div class="e-card playing">
  <div class="image"></div>

  <div class="wave"></div>
  <div class="wave"></div>
  <div class="wave"></div>


  <div class="infotop">
    <svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512" width="24" height="24" preserveAspectRatio="xMidYMid meet"
      style="width: 20%; height: 20%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;"
      id="Alert Symbol">
      <defs>
        <clipPath id="__lottie_element_93">
          <rect width="512" height="512" x="0" y="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#__lottie_element_93)">
        <g transform="matrix(1,0,0,1,374.343994140625,895.2490234375)" opacity="1" style="display: none;">
          <g opacity="1" transform="matrix(1,0,0,1,-118.34400177001953,-639.2490234375)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-213.0500030517578,147.16700744628906 C-151.74099731445312,34.65800094604492 -83.60800170898438,-74.13200378417969 -9.152000427246094,-178.4080047607422 C-4.466000080108643,-184.9709930419922 0.8199999928474426,-191.93600463867188 8.569999694824219,-194.16299438476562 C23.4689998626709,-198.44500732421875 36.33000183105469,-183.51199340820312 44.67399978637695,-170.4459991455078 C113.02100372314453,-63.41999816894531 182.44200134277344,46.05400085449219 213.0500030517578,169.29800415039062 C76.99299621582031,206.33099365234375 -68.85800170898438,206.70599365234375 -213.0500030517578,147.16700744628906z" />
          </g>
          <g opacity="1" transform="matrix(1,0,0,1,-112.2760009765625,-670.18701171875)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-1.2239999771118164,-61.34000015258789 C-3.380000114440918,-20.441999435424805 -2.2090001106262207,20.631000518798828 2.2720000743865967,61.34000015258789" />
          </g>
          <g opacity="1" transform="matrix(1,0,0,1,-103.4739990234375,-526.2479858398438)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-9.244999885559082,-0.9120000004768372 C-3.2109999656677246,0.5640000104904175 3.0409998893737793,1.1510000228881836 9.244999885559082,0.8240000009536743" />
          </g>
        </g>
        <g transform="matrix(1,0,0,1,374.343994140625,894.8790283203125)" opacity="1" style="display: block;">
          <g opacity="1" transform="matrix(1,0,0,1,-118.34400177001953,-638.8790283203125)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-213.0500030517578,146.7969970703125 C-144.86700439453125,31.07200050354004 -81.0989990234375,-95.51499938964844 8.560999870300293,-194.5399932861328 C44,-194 200.31700134277344,102.322998046875 213.0500030517578,168.927001953125 C76.99299621582031,205.9600067138672 -68.85800170898438,206.33599853515625 -213.0500030517578,146.7969970703125z" />
          </g>
          <g opacity="1" transform="matrix(1,0,0,1,-112.2760009765625,-670.18701171875)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-1.2239999771118164,-61.34000015258789 C-3.380000114440918,-20.441999435424805 -2.2090001106262207,20.631000518798828 2.2720000743865967,61.34000015258789" />
          </g>
          <g opacity="1" transform="matrix(1,0,0,1,-103.4739990234375,-526.2479858398438)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-9.244999885559082,-0.9120000004768372 C-3.2109999656677246,0.5640000104904175 3.0409998893737793,1.1510000228881836 9.244999885559082,0.8240000009536743" />
          </g>
        </g>
        <g transform="matrix(1,0,0,1,374.2449951171875,901.1539916992188)" opacity="1" style="display: none;">
          <g opacity="1" transform="matrix(1,0,0,1,-118.24500274658203,-645.1539916992188)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-212.9510040283203,152.5330047607422 C-144.76800537109375,36.803001403808594 -80.9990005493164,-89.7760009765625 8.66100025177002,-188.8040008544922 C23.569000244140625,-193.07899475097656 36.42900085449219,-178.14599609375 44.77299880981445,-165.0800018310547 C162.67100524902344,-4.666999816894531 212.9510040283203,175.2030029296875 212.9510040283203,175.2030029296875 C212.9510040283203,175.2030029296875 18.024999618530273,219.44900512695312 -212.9510040283203,152.5330047607422z" />
          </g>
          <g opacity="1" transform="matrix(1,0,0,1,-112.0780029296875,-670.7260131835938)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-1.2239999771118164,-61.34000015258789 C-3.380000114440918,-20.441999435424805 -2.2090001106262207,20.631000518798828 2.2720000743865967,61.34000015258789" />
          </g>
          <g opacity="1" transform="matrix(1,0,0,1,-103.2760009765625,-526.7869873046875)">
            <path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="10"
              stroke="rgb(255,255,255)" stroke-opacity="1" stroke-width="53.097"
              d=" M-9.244999885559082,-0.9120000004768372 C-3.2109999656677246,0.5640000104904175 3.0409998893737793,1.1510000228881836 9.244999885559082,0.8240000009536743" />
          </g>
        </g>
      </g>
    </svg>
    <br>
    Not Found
    <br>
    <div class="name">
      <a (click)="goBack()" style="color: rgba(255, 255, 255, 0.696);text-decoration: none; ">Go Back?</a>
    </div>
    <div class="name" style="margin-top: 10px;">
      <a (click)="goToDashboard()" style="color: rgba(255, 255, 255, 0.696);text-decoration: none; ">Back to
        Dashboard?</a>
    </div>

  </div>
</div>